export type Theme = "blue" | "light" | "dark" | "system";
export type ResolvedTheme = Exclude<Theme, "system">;

export function resolveTheme(theme: Theme, systemDark: boolean): ResolvedTheme {
  return theme === "system" ? (systemDark ? "dark" : "blue") : theme;
}

export function toggledTheme(theme: Theme, systemDark: boolean): Theme {
  return resolveTheme(theme, systemDark) === "dark" ? "blue" : "dark";
}
